import PropTypes from 'prop-types';
import React from 'react';
import styled, { keyframes } from 'styled-components';

const LoadingBar = ({ backgroundColor }) => (
  <Root>
    <Line backgroundColor={backgroundColor} />
  </Root>
);

LoadingBar.propTypes = {
  backgroundColor: PropTypes.string
};

LoadingBar.defaultProps = {
  backgroundColor: '#00416f'
};

const runnignLine = keyframes`
  /* 0% { 
    transform: translateX(-100%);
  }
  100% { 
    transform: translateX(700%);
  }  */
	0%{
		margin-left: -100%;
	}

	100%{
		margin-left: 100%;
	}
`;

const Root = styled.div`
  width: 100%;
  height: 4px;
  background-color: #ccc;
  border-radius: 2px;
  overflow: hidden;
`;

const Line = styled.span`
  display: block;
  /* width: 15%; */
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background-color: ${({ backgroundColor }) => `${backgroundColor}`};
  animation: ${runnignLine} 1.8s ease-out infinite;
`;

export default LoadingBar;
